
export default {
  props: {
    suggestion: {type: Object, required: true},
    selected: {type: Boolean, default: false},
    checkIcon: {type: Boolean, default: false},
  },
  computed: {
    name(){
      return this.suggestion.display_name
    },
  },
}
